import ensureLovelyChart from './lovelyChart.async';

import 'lovely-chart/LovelyChart.css';

export default ensureLovelyChart;
